<template>
  <div>
    <form>
      <div class="adminform form-horizontal">
        <template v-for="field in formDefinition.form.fieldset.field">
          <Input
            v-if="field.type==='text'"
            :value="data[field.name]"
            :name="field.name"
            :label="field.label"
            :description="field.description"
            :default-value="field.default"
            @update:value="data[field.name] = $event"
          />
          <Select
            v-else-if="field.type==='list'"
            :value="data[field.name]"
            :name="field.name"
            :label="field.label"
            :description="field.description"
            :options="field.option"
            :default-value="field.default"
            @update:value="data[field.name] = $event"
          />
          <Radio
            v-else-if="field.type==='radio'"
            :value="data[field.name]"
            :name="field.name"
            :label="field.label"
            :description="field.description"
            :options="field.option"
            :default-value="field.default"
            @update:value="data[field.name] = $event"
          />
          <ImageSelector
            v-else-if="field.type==='imageselector'"
            :value="data.image"
            :load-folders-url="loadFoldersUrl"
            :load-files-url="loadFilesUrl"
            :name="field.name"
            :label="field.label"
            :description="field.description"
            @update:value="data.image = $event"
          />
          <div v-else>
            Unsupported form element {{ field }}
          </div>
        </template>
      </div>
      <div class="sticky-button-container">
        <div id="imagetagfield">
          {{ tagContent }}
        </div>

        <button class="pull-right btn btn-primary" @click="insertImageContentTag">
          {{ i18n.t('COM_EVENTGALLERY_CONTENTPLUGINBUTTON_BUTTON_INSERT') }}
        </button>
      </div>
    </form>
  </div>
</template>
<script>

    import ImageSelector from "./ImageSelector.vue";
    import Input from "./Input.vue";
    import Select from "./Select.vue";
    import Radio from "./Radio.vue";

    export default {
        components: {
            ImageSelector, Input, Select, Radio
        },
        props: {
            editorName: null,
            loadFoldersUrl: null,
            loadFilesUrl: null,
            formId: null,
            formDefinitionJson: null,
            i18n: null
        },
        data() {
            return {
                data: {
                    attr: null,
                    image_crop: null,
                    image_mode: null,
                    image_width: null,
                    cssclass: null,
                    use_cart: null,
                    image: {
                        file: null,
                        folder: null,
                        thumb: null
                    },
                },
                formDefinition: JSON.parse(this.formDefinitionJson),
            };
        },
        computed: {
            tagContent: function() {
                let tag = "{eventgallery-image ";

                tag = tag + "event='" + this.data.image.folder + "' ";
                tag = tag + "file='" + this.data.image.file + "' ";

                tag = tag + "attr='"+ this.data.attr +"' ";

                if (this.data.attr === "image" || this.data.attr === "figure") {
                    tag = tag + "mode='"+ this.data.image_mode +"' ";
                    tag = tag + "crop='"+ this.data.image_crop +"' ";
                    if (this.data.image_width) tag = tag + "thumb_width='"+ this.data.image_width + "' ";
                    if (this.data.cssclass) tag = tag + "cssclass='"+ this.data.cssclass + "' ";
                    if (this.data.use_cart) tag = tag + "use_cart='"+ this.data.use_cart + "' ";
                }

                tag = tag + "}";

                return tag
            }
        },
        methods: {
            insertImageContentTag: function() {
                console.log(this.tagContent);

                window.parent.Joomla.editors.instances[this.editorName].replaceSelection(this.tagContent);
                window.parent.Joomla.Modal.getCurrent().close();


                return false;
            }
        }
    };
</script>
<style>
#imagetagfield {
   font-family: "Courier New", Courier, monospace;
   padding: 10px;
   border-radius: 5px;
   background-color: var(--gray-200, #DDDCDC);
   color: var(--body-text, black);
   margin-bottom: 0;
   flex-grow: 1;
   margin-right: 15px;
   word-break: break-all;
   font-size: 0.9em;
}
.sticky-button-container {
  position: sticky;
  bottom: 0px;
  background-color: var(--body-bg, #ffffff);
  padding: 15px 0;
  margin-top: 20px;
  z-index: 10;
  border-top: 1px solid var(--border-color, #ddd);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sticky-button-container .btn {
  white-space: nowrap;
}
</style>
